import { Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import moment from 'moment';

import { FloatingFormItem } from '@/components/_common';
import { CreatePartVehicleApplicationFreeFormValues } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import { useDefaultEmptyFieldError } from '@/hooks';

interface Props {
  form: FormInstance<CreatePartVehicleApplicationFreeFormValues>;
}
const PartApplicationFreeModalForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const fieldRequired = useDefaultEmptyFieldError();

  const [selectedFromYear, setSelectedFromYear] = useState<number>();

  const years = new Array(72)
    .fill('')
    .map((_, index) => moment().subtract(index, 'years'));

  const handleValuesChanged = (
    valuesChanged: CreatePartVehicleApplicationFreeFormValues,
  ) => {
    if (valuesChanged.fromYear) {
      setSelectedFromYear(valuesChanged.fromYear);
    }
  };

  const initialYearOptions = years.map((year) => ({
    value: year.format('YYYY'),
    label: year.format('YYYY'),
  }));

  const finalYearOptions = years
    .filter((years) => years > moment(selectedFromYear))
    .map((year) => ({
      value: year.format('YYYY'),
      label: year.format('YYYY'),
    }));

  return (
    <Form form={form} onValuesChange={handleValuesChanged}>
      <Row gutter={[16, 6]}>
        <Col span={24}>
          <FloatingFormItem
            name="description"
            label="Descrição (Máximo 300 caracteres)"
            rules={[fieldRequired]}
          >
            <Input.TextArea rows={4} maxLength={300} />
          </FloatingFormItem>
        </Col>

        <Col xs={12}>
          <FloatingFormItem
            name="fromYear"
            label={intl.formatMessage({
              id: 'parts.application.modal.form.fromYear',
            })}
          >
            <Select
              showSearch
              allowClear
              filterOption={(input, option) =>
                `${option?.label}`.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={initialYearOptions}
            />
          </FloatingFormItem>
        </Col>

        <Col xs={12}>
          <FloatingFormItem
            name="toYear"
            label={intl.formatMessage({
              id: 'parts.application.modal.form.toYear',
            })}
          >
            <Select
              showSearch
              allowClear
              disabled={!form.getFieldValue('fromYear')}
              filterOption={(input, option) =>
                `${option?.label}`.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={finalYearOptions}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default PartApplicationFreeModalForm;
